export const firebaseConfig = {
    apiKey: "AIzaSyAOwsC_n3TTD59Uqx2RrykZ2851OZMro5M",
    authDomain: "gateopener-staging-da05d.firebaseapp.com",
    projectId: "gateopener-staging-da05d",
    storageBucket: "gateopener-staging-da05d.appspot.com",
    messagingSenderId: "294792866174",
    appId: "1:294792866174:web:3e3aa26091752478a2eb2f",
};
